<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-head-top"><a href="#/Text/81388_content#p1"><span class="blue">PART ONE</span></a></p>
<div class="head2"></div>
<p class="big-head"><a href="#/Text/81388_content#p1"><span class="blue">BEGINNINGS</span></a></p>
<div class="head2"></div>
<p class="part-ital-head">There was no notion of where we were going, but no known cure either.</p>
<div class="partimages"><img alt="" src="Images/part1_001.jpg"/></div>
<p class="phototxtfirst">© Redferns</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 81388_part1.vue?ebda0e12